export const baseAvatarStyle = {
  width: '2em',
  height: '2em',
  display: 'inline-block',
  position: 'relative',
  overflow: 'hidden',
  userSelect: 'none',
  cursor: 'inherit',
};
